import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display a user field in the invoice list with a link to the user's detail page
 * Uses the embedded user object from the invoice API response
 */
const InvoiceUserField: React.FC<FieldProps<any>> = ({
    record,
    link = 'show',
}) => {
    if (!record || !record.user) return null;

    const { user } = record;

    if (!user.id || !user.name)
        return <span>{user.name || user.email || 'Unknown'}</span>;

    return link ? (
        <Link to={`/users/${user.id}/show`}>{user.name || user.email}</Link>
    ) : (
        <span>{user.name || user.email}</span>
    );
};

InvoiceUserField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

InvoiceUserField.defaultProps = {
    addLabel: true,
    label: 'Customer',
};

export default InvoiceUserField;
